import styled from "styled-components";
import { FlexColumn, CenterFlexRow, FlexRow } from "styles/layout";
import { Theme } from "theme";

export const CommunityGridContainer = styled(CenterFlexRow)`
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 10px;
`;

export const CommunityGridItem = styled.div`
  width: 280px;
  height: 150px;
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${Theme.panelHoverBackground};
    cursor: pointer;
  }
`;

export const LinkIcon = styled.div`
  position: absolute;
  height: 15px;
  width: 18px;
  top: 2px;
  right: 4px;
`;

export const Icon = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

export const UnicodeIcon = styled.span`
  font-size: 13pt;
`;

export const CommunityContainer = styled(FlexColumn)`
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  row-gap: 5px;
`;

export const NameLogoContainer = styled(FlexRow)`
  padding-top: 2px;
`;

export const Name = styled.span`
  font-size: 12pt;
`;

export const LogoContainer = styled.div`
  width: 40px;
  height: 40px;
  border: 1px solid black;
`;

export const Description = styled.div`
  font-size: 10pt;
  color: dimgray;
`;

export const Tags = styled(FlexRow)`
  margin-top: auto;
  column-gap: 2px;
`;
